// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.polaznik-container-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 0px;
  border-bottom: 1px solid #d1d9e2;
}
.polaznik-username {
  color: #4d4d4d;
  font-size: 20px;
}
.polaznik-username,
.self-add-hrs {
  font-family: Inter;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02px;
  font-style: normal;
}
.self-add-hrs {
  width: 200px;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  background: #cb9c2d;
  color: #fff;
  font-size: 16px;
}
.rucni-unos-dropdown {
  position: absolute;
  height: auto;
  right: 8%;
  width: 17%;
  margin-top: 16px;
  background: #ffffff;
  box-shadow: 0px 4px 17px 0px #5f6d7e29;
  border-radius: 8px;
  z-index: 30;
}
.rucni-unos-list {
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 100;
  padding: 0px 16px 0px 16px;
  margin-top: 0;
  height: 46px;
  text-align: left;
}
.rucni-unos-list:hover {
  background-color: #e0e0e2;
}
.rucni-unos-list:hover,
.self-add-hrs:hover {
  cursor: pointer;
  transition: background-color 300ms;
}
.self-add-hrs:hover {
  background-color: #aa8327;
}
.header-link {
  text-decoration: none;
  color: #5f6d7ec7;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
}

@media screen and (max-width: 1350px) {
  .self-add-hrs {
    width: 250px;
  }
  .rucni-unos-dropdown {
    width: 250px;
    right: 7.3%;
  }
}

@media screen and (max-width: 1050px) {
  .rucni-unos-dropdown {
    right: 6.7%;
  }
}

@media screen and (max-width: 850px) {
  .rucni-unos-dropdown {
    right: 6%;
  }
}

@media screen and (max-width: 700px) {
  .rucni-unos-dropdown {
    right: 5%;
  }
}

@media screen and (max-width: 600px) {
  .polaznik-container-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
  }
  .self-add-container {
    width: 100%;
  }
  .self-add-hrs {
    min-width: 100%;
  }
  .rucni-unos-dropdown {
    left: auto;
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/components/Polaznik/Polaznik.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,UAAU;EACZ;AACF","sourcesContent":[".polaznik-container-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 0px;\n  border-bottom: 1px solid #d1d9e2;\n}\n.polaznik-username {\n  color: #4d4d4d;\n  font-size: 20px;\n}\n.polaznik-username,\n.self-add-hrs {\n  font-family: Inter;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.02px;\n  font-style: normal;\n}\n.self-add-hrs {\n  width: 200px;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  background: #cb9c2d;\n  color: #fff;\n  font-size: 16px;\n}\n.rucni-unos-dropdown {\n  position: absolute;\n  height: auto;\n  right: 8%;\n  width: 17%;\n  margin-top: 16px;\n  background: #ffffff;\n  box-shadow: 0px 4px 17px 0px #5f6d7e29;\n  border-radius: 8px;\n  z-index: 30;\n}\n.rucni-unos-list {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  z-index: 100;\n  padding: 0px 16px 0px 16px;\n  margin-top: 0;\n  height: 46px;\n  text-align: left;\n}\n.rucni-unos-list:hover {\n  background-color: #e0e0e2;\n}\n.rucni-unos-list:hover,\n.self-add-hrs:hover {\n  cursor: pointer;\n  transition: background-color 300ms;\n}\n.self-add-hrs:hover {\n  background-color: #aa8327;\n}\n.header-link {\n  text-decoration: none;\n  color: #5f6d7ec7;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n\n@media screen and (max-width: 1350px) {\n  .self-add-hrs {\n    width: 250px;\n  }\n  .rucni-unos-dropdown {\n    width: 250px;\n    right: 7.3%;\n  }\n}\n\n@media screen and (max-width: 1050px) {\n  .rucni-unos-dropdown {\n    right: 6.7%;\n  }\n}\n\n@media screen and (max-width: 850px) {\n  .rucni-unos-dropdown {\n    right: 6%;\n  }\n}\n\n@media screen and (max-width: 700px) {\n  .rucni-unos-dropdown {\n    right: 5%;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .polaznik-container-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 30px;\n  }\n  .self-add-container {\n    width: 100%;\n  }\n  .self-add-hrs {\n    min-width: 100%;\n  }\n  .rucni-unos-dropdown {\n    left: auto;\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
